<template>
<div id="mini-profile" class="dark-bg center-text">
	<div v-if="typeof user === 'object'">
		<div class="banner">
			<user-image :user="user" :animate="true" />
		</div>
		<user-name :user="user" />
		<span v-show="user.props.vanity"
			class="small"
		>
			a.k.a. {{ user.props.name }}
		</span>
		<p class="statusMsg">
			{{ user.props.statusMsg }}
		</p>
		<div class="lighter-background small-padding shorter-padding">
			<div class="buttons grid-2 ">
				<button class="smaller-padding vanishing"
					@click="openMessage()"
				>
					Message
				</button>
				<button class="smaller-padding vanishing"
					@click="openProfile()"
				>
					Profile
				</button>
			</div>
			<psuedo-textarea ref="textarea"
				class="vanishing small full-width small-padding shorter-padding"
				:placeholder="namedPlaceholder"
				:value="note"
				@input="updateNote"
			>
				<p>{{ note }}</p>
			</psuedo-textarea>
			<ul v-if="user.props.badges"
				class="flex-parent flex-center"
			>
				<li
					v-for="(value, key) in user.props.badges"
					:key="key"
					:title="badgeHumanReadable(key)"
				>
					<img class="badge"
						:src="badgeIcon(key)"
					>
				</li>
			</ul>
			<p class="small">
				Right-click name for more
			</p>
		</div>
	</div>
	<div v-else>
		Loading...
	</div>
</div>
</template>

<script>
import UserImage from './user-image.vue'
import UserName from './user-name.vue'
import PsuedoTextarea from './psuedo-textarea.vue'
import settings from '../js/settings.js'
import badges from '../json/shared/badges.json'
import account from '../js/account.js'

export default {
	components: {
		'user-image': UserImage,
		'user-name': UserName,
		'psuedo-textarea': PsuedoTextarea
	},
	props: {
		user: {
			type: [Object, Boolean],
			required: true
		}
	},
	data: () => ({
		note: '',
		badges
	}),
	computed: {
		namedPlaceholder(){
			return `Add note for ${this.user && this.user.props.name}`
		}
	},
	watch: {
		user: {
			handler: function( user ){
				if( user ){
					this.note = settings.notes[user.props.id] || ''
					if( typeof this.note === 'string' ){
						this.note = this.note.trim().replace( /\n/g, '<br />' )
					}
					if( this.$refs.textarea ){
						this.$refs.textarea.$el.blur()
					}
				}
			},
			immediate: true
		}
	},
	methods: {
		openProfile(){
			window.open( `//profiles.rphaven.com/${this.user.props.name}`, '_blank' )
		},
		openMessage(){
			this.user.newPm()
		},
		updateNote( ev ){
			settings.notes[this.user.props.id] = ev.target.value
				.replace( /<br\s*\/*>/ig, '\n' )
				.replace( /(<(p|div))/ig, '\n$1' )
				.replace( /(<([^>]+)>)/ig, '' )
			settings.save()
		},
		badgeHumanReadable( badgeId ){
			const value = account.priv.badges[badgeId]
			// eslint-disable-next-line no-eval
			return eval( badges[badgeId] && '`' + badges[badges[badgeId]].human_readable + '`' )
		},
		badgeIcon( badgeId ){
			return ( badges[badgeId] && badges[badges[badgeId]].img_src ) || ''
		}
	}
}
</script>